<template>
  <div class="page cross-rate-page">
    <div class="header">
      <div class="title">
        Кросс Курс
      </div>
    </div>
    <div class="content">
      <el-card shadow="always" class="main-card" v-loading="loadingStatus">
        <div slot="header">
          <el-row :gutter="20">
            <el-col :span="24" :offset="0">Фильтры</el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="18" :offset="0">
              <div>
                <el-form ref="form">
                  <el-form-item>
                    <el-select
                      class="bottom-space"
                      placeholder="From (мы покупаем)"
                      clearable
                      filterable
                      v-model="fromFilter"
                      size="mini"
                    >
                      <el-option
                        v-for="item in valutes"
                        :key="item._id"
                        :label="item.title + ' - ' + item.key"
                        :value="item._id"
                      >
                      </el-option>
                    </el-select>

                    <el-select
                      class="bottom-space"
                      placeholder="To (мы продаем)"
                      clearable
                      filterable
                      v-model="toFilter"
                      size="mini"
                    >
                      <el-option
                        v-for="item in valutes"
                        :key="item._id"
                        :label="item.title + ' - ' + item.key"
                        :value="item._id"
                      >
                      </el-option>
                    </el-select>
                    <el-select
                      class="bottom-space"
                      placeholder="Город"
                      clearable
                      filterable
                      v-model="cityFilter"
                      size="mini"
                    >
                      <el-option
                        v-for="item in valuteCities"
                        :key="item._id"
                        :label="item.name"
                        :value="item._id"
                      >
                      </el-option>
                    </el-select>
                    <el-select
                      class="bottom-space"
                      placeholder="Активен?"
                      clearable
                      filterable
                      v-model="isActiveFilter"
                      size="mini"
                    >
                      <el-option key="false" label="Нет" value="false">
                      </el-option>
                      <el-option key="true" label="Да" value="true">
                      </el-option>
                    </el-select>
                    <el-select
                      class="bottom-space"
                      placeholder="Тип"
                      multiple
                      collapse-tags
                      clearable
                      filterable
                      v-model="showTypesFilter"
                      size="mini"
                    >
                      <el-option
                        v-for="item in allTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <el-button
                      size="mini"
                      class="bottom-space"
                      v-if="isFiltered"
                      type="danger"
                      @click="resetSearch"
                      >Сбросить фильтры</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
            </el-col>
            <el-col :span="6" :offset="0">
              <div>
                <el-button
                  :loading="loading"
                  @click="getAllData"
                  circle
                  icon="el-icon-refresh"
                ></el-button>
                <!-- <el-button
                  v-if="session.type === 1 || session.type === -1"
                  @click.prevent="addCrossRate()"
                  type="success"
                  class="add-btn bottom-space"
                  >Добавить кросс курс</el-button
                  > -->
                <el-button
                  v-if="session.type === 1 || session.type === -1"
                  type="primary"
                  round
                  icon="el-icon-plus"
                  @click="$router.push({ name: 'CrossRateNew' })"
                  >Добавить</el-button
                >
              </div>
            </el-col>
          </el-row>
        </div>

        <div
          v-if="
            typeof crossRates.docs !== 'undefined' && crossRates.docs.length
          "
        >
          <el-table
            @sort-change="handleSortChange"
            :default-sort="{ prop: '_id', order: 'descending' }"
            :data="crossRates.docs"
            border
            stripe
          >
            <el-table-column
              min-width="150"
              sortable="custom"
              prop="from"
              label="From (мы покупаем)"
            >
              <template v-slot="scope">
                {{ scope.row.from.title }}
              </template>
            </el-table-column>
            <el-table-column
              min-width="150"
              sortable="custom"
              prop="to"
              label="To (мы продаем)"
            >
              <template v-slot="scope">
                {{ scope.row.to.title }}
              </template>
            </el-table-column>
            <el-table-column
              min-width="150"
              sortable="custom"
              prop="city"
              label="Город"
            >
              <template v-slot="scope">
                {{
                  scope.row.city && scope.row.city.name
                    ? scope.row.city.name
                    : ""
                }}
              </template>
            </el-table-column>
            <el-table-column
              min-width="150"
              sortable="custom"
              prop="out"
              label="Курс"
            ></el-table-column>
            <el-table-column
              min-width="70"
              sortable="custom"
              prop="isActive"
              label="Активен"
            >
              <template v-slot="scope">
                <ActiveIcon :val="scope.row.isActive" />
              </template>
            </el-table-column>

            <el-table-column min-width="150" label="Тип">
              <template v-slot="scope">
                <div v-if="scope.row.isDisabled">
                  Скрытый
                </div>
                <div v-if="scope.row.makeTopIsActive">
                  <div>
                    В топ Беста
                  </div>
                  <div>Лимит: {{ scope.row.makeTopLimitMult }}</div>
                  <div>Отступ: {{ scope.row.makeTopStep }}</div>
                </div>
                <div v-if="scope.row.makePlaceIsActive">
                  <div>
                    На позицию Беста
                  </div>
                  <div>Место: {{ scope.row.makePlaceNumber }}</div>
                  <div>Отступ: {{ scope.row.makePlaceStep }}</div>
                </div>
                <div v-if="scope.row.isFixed">
                  Фиксированный
                </div>
              </template>
            </el-table-column>
            <el-table-column
              min-width="180"
              sortable="custom"
              prop="updatedAt"
              label="Обновление"
            >
              <template v-slot="scope">
                <div v-if="scope.row.updatedAt">
                  <!-- <el-row :gutter="20">
                    <el-col :span="20" :offset="0">
                      {{
                        $dayjs(scope.row.updatedAt).format("DD.MM.YY HH:mm:ss")
                      }}
                    </el-col>
                  </el-row> -->
                  <el-row :gutter="20">
                    <el-col :span="20" :offset="0">
                      {{ $dayjs(scope.row.updatedAt).fromNow() }}
                    </el-col>
                  </el-row>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              min-width="75"
              label="Инструменты"
              v-if="session.type === 1 || session.type === -1"
            >
              <template v-slot="scope">
                <router-link
                  :to="{ name: 'CrossRateEdit', params: { id: scope.row._id } }"
                >
                  <i class="el-icon-edit edit"></i>
                </router-link>
                <!-- <i
                  class="el-icon-edit edit"
                  @click.prevent="editCrossRateInModal(scope.row)"
                ></i> -->
                <el-popconfirm
                  icon="el-icon-delete"
                  icon-color="red"
                  :title="
                    `Удалить кросс курс '${scope.row.from.title} - ${scope.row.to.title}'?`
                  "
                  @confirm="removeCrossRate(scope.row)"
                >
                  <i slot="reference" class="el-icon-delete delete"></i>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCrossRatesPage"
            @size-change="handleCrossRatesLimit"
            :current-page.sync="crossRates.page"
            :page-size="crossRates.limit"
            layout="sizes, prev, pager, next, jumper"
            :total="crossRates.totalDocs"
          >
          </el-pagination>
        </div>
        <div v-else class="text-center">
          Нет данных
        </div>
      </el-card>
    </div>
    <EditCrossRateComponent />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
//
import EditCrossRateComponent from "./components/EditCrossRate";
import ActiveIcon from "../../ui/ActiveIcon.vue";
//
const allTypes = [
  {
    value: "isDisabled",
    label: "Скрытый"
  },
  {
    value: "makeTopIsActive",
    label: "В топ Беста"
  },
  {
    value: "makePlaceIsActive",
    label: "На позицию Беста"
  },
  {
    value: "isFixed",
    label: "Фиксированный"
  }
];
const defaultFormData = {
  from: null,
  to: null,
  out: null,
  city: null,
  isActive: true,
  makeTopIsActive: false,
  makeTopLimitMult: 1.1,
  makeTopStep: 0,
  makeTopIgnoredExchangeNames: 0
};

export default {
  name: "CrossRate",
  components: { EditCrossRateComponent, ActiveIcon },

  data: () => ({
    activeFormIndex: -1,
    activeForm: defaultFormData,
    allTypes
  }),

  computed: {
    ...mapState("auth", ["session"]),
    ...mapState("crossRate", [
      "crossRates",
      "valutes",
      "valuteCities",
      "loading",
      "from",
      "to",
      "city",
      "isActive",
      "showTypes",
      "isFiltered",
      "makeTopIsActive"
    ]),
    loadingStatus: {
      get() {
        return this.loading;
      },
      set(val) {
        this.changeLoading({ loading: val });
      }
    },
    fromFilter: {
      get() {
        return this.from;
      },
      set(val) {
        this.changeFrom({ from: val });
      }
    },
    toFilter: {
      get() {
        return this.to;
      },
      set(val) {
        this.changeTo({ to: val });
      }
    },
    cityFilter: {
      get() {
        return this.city;
      },
      set(val) {
        this.changeCity({ city: val });
      }
    },
    showTypesFilter: {
      get() {
        return this.showTypes;
      },
      set(val) {
        this.changeShowTypes({ showTypes: val });
      }
    },
    isActiveFilter: {
      get() {
        return this.isActive;
      },
      set(val) {
        this.changeIsActive({ isActive: val });
      }
    }
  },

  methods: {
    ...mapActions("crossRate", [
      "queryPaginationCrossRates",
      "getValutes",
      "getValuteCities",
      "deleteCrossRate",
      "changeFrom",
      "changeTo",
      "changeCity",
      "changeIsActive",
      "changeShowTypes",
      "changeDataInModal",
      "changeDialogVisible",
      "performSearch",
      "resetSearch",
      "goToPage",
      "changeSorting",
      "changeLimit",
      "changeLoading"
    ]),

    addCrossRate() {
      this.changeDataInModal({});
      this.changeDialogVisible({ dialogVisible: true });
    },

    editCrossRateInModal(crossRate) {
      this.changeDataInModal({ crossRateInModal: { ...crossRate } });
      this.changeDialogVisible({ dialogVisible: true });
    },

    removeCrossRate(crossRate) {
      this.deleteCrossRate(crossRate._id).then(() => {
        this.$nextTick().then(() =>
          this.$message.success("Операция прошла успешно")
        );
      });
    },

    handleCrossRatesPage(page) {
      this.goToPage({ page });
    },

    handleCrossRatesLimit(limit) {
      this.changeLimit({ limit });
    },

    handleSortChange(sortData) {
      const sort =
        sortData.order === "ascending"
          ? sortData.prop
          : sortData.order === "descending"
          ? `-${sortData.prop}`
          : "";
      this.changeSorting({ sort });
    },
    async getAllData() {
      try {
        await this.queryPaginationCrossRates();
        await this.getValutes();
        await this.getValuteCities();
      } catch (error) {
        this.handleResponseError(error);
      }
    }
  },

  async mounted() {
    await this.getAllData();
  }
};
</script>

<style scoped>
.cross-rate-page >>> input {
  margin-bottom: 0;
}

.cross-rate-page >>> .cell {
  margin-left: 0;
  margin-right: 0;
}

.main-card {
  width: 100%;
  padding: 20px;
}

.main-card >>> .el-card__header {
  padding-bottom: 3px;
}

.el-pagination {
  padding: 15px 5px;
  margin-left: -10px;
}

.delete {
  color: red;
}

.edit {
  color: orange;
  margin-right: 5px;
}

.delete,
.edit {
  font-size: 1.5em;
  cursor: pointer;
}

label {
  display: block;
}

.bottom-space {
  margin-bottom: 15px;
}

.el-form-item {
  margin-bottom: 0;
}

.add-btn {
  float: right;
  position: relative;
  z-index: 2;
}

.text-center {
  text-align: center;
}

.content {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/CrossRate/index.vue